/*eslint-disable*/
import './reviewBooking.css';
import { useContext, useEffect, useRef, useState } from 'react';
import ReviewBookInfo from './reviewBookSection/reviewBookInfo/ReviewBookInfo';
import ReviewBookSumm from './reviewBookSection/reviewBookSumm/ReviewBookSumm';
import errorHandle from '../../utils/errorHandle';
import { toast } from 'react-toastify';
import { bookingStatus, createOrderId, tripAvaFun, tripReserveFun, tripReserveGuestFun } from '../../api/bookingOrgApi';
import ReactLoading from 'react-loading';
import { Navigate } from 'react-router-dom';
import emailValid from '../../utils/emailValid';
import phoneValid from '../../utils/phoneValid';
import TitleBar from '../../components/titleBar/titleBar';
import Payment from '../../components/payment/payment';
import { claimCashOrCoins } from '../../api/userApi';
import moment from 'moment';
import { getTaxAmount } from '../../utils/getAmountWithTransaction';
import { useNavigate } from 'react-router-dom';
import { BookingDataContext } from '../../context/BookingDataContext';
// import { useOrganizer } from '../../context/OrganizerContext';
// import CustomHeader from '../../../webPageSections/header/orgHeader/CustomHeader';
// import { useTempOrg } from '../../../context/TempOrgContext';
// import { UserAuthContext } from '../../../context/UserAuthContext';

export default function ReviewBooking() {
    const { bookingData, setBookingData } = useContext(BookingDataContext);
    const bookedData = JSON.parse(localStorage.getItem('bookedData') || null);
    const [finalData, setFinalData] = useState({});
    const peopleCount = parseInt(bookingData?.people) || 0;
    const [paymentType, setPaymentType] = useState(bookingData?.paymentType || 'UPI');
    const [changeLoading, setChangeLoading] = useState(false);
    const [offerType, setOfferType] = useState('');
    const [cashToRedeem, setCashToRedeem] = useState(0);
    const [userDetails, setUserDetails] = useState(() =>
        Array.from({ length: peopleCount }, () => ({
            name: '',
            age: 0,
            sex: '',
            countryCode: '+91',
            phoneNumber: '',
            emailId: ''
        }))
    );

    const [navHome, setNavHome] = useState(false);
    const [navDetails, setNavDetails] = useState(false);
    const [selectedType, setSelectedType] = useState(bookingData.selectedType ?? ''); // "cash" or "coins"
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [guest, setGuest] = useState(false);
    const [paymentData, setPaymentData] = useState({
        reserveId: '',
        abandonId: '',
        orderId: ''
    });
    const [loggedInUser, setLoggedInUser] = useState({});
    const [options, setOptions] = useState({
        amount: '',
        name: '',
        description: '',
        order_id: '',
        prefill: {
            name: '',
            email: '',
            contact: ''
        }
    });
    const paymentRef = useRef();
    const navigate = useNavigate();

    // function checkData() {
    //     if (userDetails.length === +bookingData.people) {
    //         return userDetails.every((obj) => Object.values(obj).every((value) => value !== ''));
    //     } else {
    //         return false;
    //     }
    // }

    useEffect(() => {
        const userDataa = JSON.parse(localStorage.getItem('userData1'));
        const paymentMethod = localStorage.getItem('paymentType');
        if (userDataa && paymentData) {
            setUserDetails(userDataa);
            setPaymentType(paymentMethod);
        }
        localStorage.setItem('paymentTypeChange', 'true');
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        async function checkPaymentStatus() {
            if (!bookedData?.bookingId) return;

            try {
                const res = await bookingStatus('trip', bookedData.bookingId);

                const paymentState = res?.data?.paymentInfo?.status;

                if (paymentState === 'Paid') {
                    localStorage.setItem('backendBookingData', JSON.stringify(res.data));
                    navigate('/h/booking-confirmation');
                } else if (paymentState === 'Failed') {
                    console.log('Payment not yet done');
                }
            } catch (error) {
                console.error('Polling failed:', error);
            }
        }

        // run first time
        checkPaymentStatus();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (paymentData.orderId) {
            paymentRef.current?.initiatePayment();
            window.paymentTimeout = setTimeout(() => {
                const currentPath = window.location.pathname;

                if (currentPath !== '/h/booking-confirmation') {
                    navigate('/h/payment-verification');
                }
            }, 45000);
        }
        //eslint-disable-next-line
    }, [paymentData]);

    useEffect(() => {
        setOptions({
            amount: bookingData.totalAmo * 100,
            name: bookingData.title,
            description: bookingData.title,
            order_id: '',
            prefill: {
                name: loggedInUser?.name || userDetails[0]?.name,
                email: loggedInUser?.emailId || userDetails[0]?.emailId,
                contact: loggedInUser?.phoneNumber || userDetails[0]?.phoneNumber
            }
        });
        //eslint-disable-next-line
    }, [bookingData, loggedInUser, userDetails]);

    // function checkEmailPho() {
    //     return userDetails.every((obj) => {
    //         return Object.keys(obj).every((key) => {
    //             return key === 'emailId'
    //                 ? emailValid(obj.emailId)
    //                 : key === 'phoneNumber'
    //                   ? phoneValid(obj.phoneNumber)
    //                   : true;
    //         });
    //     });
    // }

    const handleApplyOffer = (offerAmo) => {
        const totalAmo = Math.round(bookingData.totalAmo - offerAmo);

        setBookingData((prev) => ({ ...prev, totalAmo }));
    };

    const handleRemoveOffer = () => {
        // baseAmountRef.current += Math.round(cashToRedeem > 0 ? cashToRedeem : offerData.offerPrice);

        const totalAmo = Math.round(bookingData.totalAmo + bookingData.offerAmo);

        setBookingData((prev) => ({
            ...prev,
            totalAmo,
            offerCode: '',
            offerType: null,
            selectedType: null,
            offerData: {},
            offerApplied: false,
            offerAmo: 0
        }));

        setCashToRedeem(0);
        setAmount(0);
        setSelectedType('');
        toast.success('Offer removed successfully');
    };

    const handleCashOrCoins = async (e) => {
        const payload = {
            claim: selectedType,
            [selectedType]: Number(amount)
        };

        try {
            const { data } = await claimCashOrCoins(payload);
            setOfferType('cashOrcoin');
            setCashToRedeem(data.userCash ?? data.amount);
            setBookingData((prevState) => ({
                ...prevState,
                offerAmo: data.userCash ?? data.amount,
                offerType: 'cashOrcoin',
                selectedType: selectedType
            }));
            handleApplyOffer(data.userCash ?? data.amount);
        } catch (error) {
            console.error(error);
            toast.warning(error?.response?.data?.message);
        }
    };

    const formatParentData = async (res, orderInfo) => {
        if (res.data.orderId) {
            try {
                localStorage.setItem('bookedData', JSON.stringify(res.data));
                localStorage.setItem('bookingData1', JSON.stringify({ ...bookingData, ...finalData }));
                localStorage.setItem('userData1', JSON.stringify(userDetails));
                localStorage.setItem('paymentType', paymentType);
                localStorage.setItem('tripImage', bookingData.tripImage);
                localStorage.setItem('packId', bookingData.packId);
                localStorage.setItem('packDateId', bookingData.packDateId);
                const payment = {
                    orderId: res.data.orderId,
                    bookingId: res.data.bookingId
                };

                if (res.data.reserveId) {
                    payment.reserveId = res.data.reserveId;
                }

                setPaymentData(payment);
            } catch (error) {
                console.log(error);
            }
        }
    };

    async function reviewConfirm() {
        for (let i = 0; i < userDetails.length; i++) {
            const item = userDetails[i];
            const participantNum = `Participant ${i + 1}`;

            if (!item.name || item.name.trim() === '') {
                toast.error(`${participantNum}: Name is required`);
                return;
            }
            if (item.name.length > 30) {
                toast.error(`${participantNum}: Name should be less than 30 characters`);
                return;
            }
            if (!item.age || isNaN(item.age)) {
                toast.error(`${participantNum}: Age is required`);
                return;
            }
            if (item.age < 5 || item.age > 65) {
                toast.error(`${participantNum}: Age should be between 5 and 65`);
                return;
            }
            if (!item.sex || item.sex === 'Select') {
                toast.error(`${participantNum}: Gender selection is required`);
                return;
            }
            if (i === 0 && (!emailValid(item.emailId) || item.emailId === '')) {
                toast.error(`${participantNum}: email is invalid`);
                return;
            }
            if (!phoneValid(item.phoneNumber) || item.phoneNumber === '') {
                toast.error(`${participantNum}: phone number is invalid`);
                return;
            }
        }

        setLoading(true);

        try {
            const {
                packDateId,
                people,
                date,
                days,
                organizerId,
                packId,
                actualPrice,
                totalAmo,
                offerAmo,
                room,
                roomAmount,
                transport,
                isInstallment,
                isReserved,
                reservePrice,
                installmentPrice,
                startCity,
                pickupLocation,
                group,
                datesType,
                itiType,
                startDate,
                endDate,
                customTrip,
                offerData,
                amountPaid,
                vehicleType,
                vehicleModel,
                comfortable,
                emptySeats,
                vehiclePrice
            } = bookingData;

            // Check slot availability for fixed trips
            if (datesType === 'fixed') {
                const checkAva = await tripAvaFun({ packDateId, slots: people, rooms: room });
                if (!checkAva.data.status) {
                    if (checkAva.data.remainingRooms < room)
                        return toast.error('Only ' + checkAva.data.remainingRooms + ' room is available');
                    else return toast.error('Only ' + checkAva.data.remainingSlots + ' slots are available');
                }
            }

            // Format user details
            const formattedUserDetails = userDetails.map(
                ({ name, age, sex, phoneNumber, countryCode, emailId }, index) => ({
                    name,
                    age,
                    sex,
                    phoneNumber,
                    countryCode,
                    ...(index === 0 ? { emailId } : {})
                    // ...(guest ? {} : { userId: localStorage.getItem('userId') })
                })
            );

            // Base payload
            // const total = paymentType === 'UPI' ? totalAmo : totalAmo - convinienceFee;
            const actual = actualPrice * people + roomAmount + vehiclePrice;
            const offerTypeApplied =
                cashToRedeem > 0 ? (selectedType === 'coins' ? 'coins_used' : 'cash_used') : 'percentage';
            const coinsOrCashUsed =
                cashToRedeem > 0 && (selectedType === 'coins' ? { coinsUsed: amount } : { cashUsed: amount });
            const baseData = {
                slots: Number(people),
                packDateId,
                organizerId,
                packId,
                bookedVia: 'OrgWebsite',
                totalRooms: room || 0,
                totalSeats: Number(people),
                userDetails: formattedUserDetails,
                startDate: datesType === 'custom' ? startDate : date,
                endDate: datesType === 'custom' ? endDate : moment(date).add(days, 'days').toISOString(),
                datesType,
                group,
                itiType,
                transport,
                startCity,
                pickupLocation,
                offerApplied: offerData?._id || null,
                amountPaid: {
                    actual: actual,
                    tax: getTaxAmount(actualPrice * people),
                    total: actual + getTaxAmount(actualPrice * people),
                    offerAmount: cashToRedeem > 0 ? cashToRedeem : offerAmo,
                    paid: totalAmo,
                    isReserved,
                    reserve: isReserved ? reservePrice : 0,
                    isInstalment: isInstallment || false,
                    installments: isInstallment
                        ? [
                              {
                                  name: 'Installment 1',
                                  total: installmentPrice,
                                  date: new Date().toISOString(),
                                  status: 'Paid'
                              }
                          ]
                        : []
                },
                amountPerSeat: Math.round((actual + getTaxAmount(actualPrice * people)) / people)
            };

            if (offerData) {
                baseData.offerType = {
                    name: offerData?.name || '',
                    code: offerData?.code || '',
                    type: offerTypeApplied || 'fixed'
                };
            }
            if (!offerData?.id && selectedType !== '') {
                baseData.offerType = {
                    type: offerTypeApplied,
                    ...coinsOrCashUsed
                };
            }
            // Add customTrip only if datesType === 'custom'
            if (group === 'vehicle') {
                baseData.vehicle = {
                    mode: vehicleType,
                    model: vehicleModel,
                    emptySeats: emptySeats,
                    comfortable: comfortable
                };
            }
            if (datesType === 'custom') {
                const bedCount = Math.round(people / 3); // 1 bed per 3 adults
                const onlyRooms = customTrip?.rooms?.map((room) => ({ adults: room.adults }));
                const validVehicles = customTrip?.vehicleType?.filter((item) => item.vehicleCount > 0);
                baseData.customTrip = {
                    rooms: onlyRooms,
                    people,
                    bed: bedCount,
                    vehicle: validVehicles,
                    isGroup: customTrip.isGroup
                };
                // const paid = paymentType === 'UPI' ? bookingData.totalAmo : bookingData.totalAmo - convinienceFee;
                const amountPerSeat = Math.round(amountPaid.total / people);
                const final_amountPaid = {
                    ...amountPaid,
                    reserve: bookingData.amountPaid.isReserved ? reservePrice : 0,
                    paid: bookingData.totalAmo,
                    offerAmount: cashToRedeem > 0 ? cashToRedeem : offerData?.offerPrice || 0
                };

                baseData.amountPaid = final_amountPaid;
                baseData.amountPerSeat = amountPerSeat;
            }
            //  Set the correct final data
            setFinalData(baseData);
            // Send to the correct API
            // if (bookedData?.bookingId) {
            //     setPaymentData({ ...bookedData });
            //     return;
            // }
            if (datesType === 'custom') {
                await handleCustomBooking(baseData, !guest);
            } else {
                await handleReservation(baseData, guest);
            }
        } catch (error) {
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleReservation(data, isGuest) {
        try {
            // const response = isGuest ? await tripReserveGuestFun(data) : await tripReserveFun(data);
            const response = await tripReserveGuestFun(data);
            formatParentData(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleCustomBooking(data, isGuest) {
        const amount = data.amountPaid.paid + (paymentType === 'UPI' ? 0 : bookingData.convinienceFee);
        try {
            const orderInfo = await createOrderId({
                amount: amount,
                ...data
            });
            formatParentData(orderInfo);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(
        function () {
            if (Object.keys(bookingData).length === 0) {
                return setNavHome(true);
            }
        },
        [bookingData]
    );

    if (navHome) {
        return <Navigate to='/' />;
    }

    if (navDetails) {
        return <Navigate to={`/h/${bookingData.type}/details/${bookingData.packId}`} />;
    }

    if (!bookingData || Object.keys(bookingData).length === 0) {
        navigate('/');
    }

    return (
        <div style={{ marginTop: '60px' }}>
            {loading &&
                (!changeLoading ? (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                ) : (
                    <div className='loadingBackgroundPayment'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpinPayment' />
                        <p className='loadingText'>Please wait while we verify your payment…</p>
                    </div>
                ))}
            <div>
                <TitleBar title='Review Booking Details' />
            </div>
            <div className='bookingReviewDetails'>
                <ReviewBookInfo
                    userDetails={userDetails}
                    bookingData={bookingData}
                    setUserDetails={setUserDetails}
                    guest={guest}
                    setGuest={setGuest}
                />
                <div className='bookingReviewPriceDiv'>
                    <ReviewBookSumm
                        setBookingData={setBookingData}
                        bookingData={bookingData}
                        reviewConfirm={reviewConfirm}
                        loggedInUser={loggedInUser}
                        setNavDetails={setNavDetails}
                        paymentType={paymentType}
                        setOfferType={setOfferType}
                        selectedType={selectedType}
                        setSelectedType={setSelectedType}
                        amount={amount}
                        setAmount={setAmount}
                        cashToRedeem={cashToRedeem}
                        setCashToRedeem={setCashToRedeem}
                        handleCashOrCoins={handleCashOrCoins}
                        setPaymentType={setPaymentType}
                        handleApplyOffer={handleApplyOffer}
                        handleRemoveOffer={handleRemoveOffer}
                    />
                </div>
                <Payment
                    ref={paymentRef}
                    paymentType={paymentType}
                    options={options}
                    bookingData={bookingData}
                    userDetails={userDetails}
                    paymentData={paymentData}
                    tripImage={bookingData.tripImage}
                    guest={guest}
                    setLoading={setLoading}
                    setChangeLoading={setChangeLoading}
                    packData={{ packId: bookingData.packId, packDateId: bookingData.packDateId }}
                    finalData={finalData}
                />
            </div>
        </div>
    );
}
